export enum Language {
  HU = 'hu',
  EN = 'en',
  DE = 'de',
}
